export const ICH_SKU_PHOTO_MAPPING_ORG_ID = "a25f9e42-23cd-11ec-9068-066917b38554";
export const JAB_CC_SKU_PHOTO_MAPPING_ORG_ID = "332a9d47-6e36-11e8-a392-061714f61e3e";
export const SKU_PHOTO_MAPPING_ORG_IDS = [
	ICH_SKU_PHOTO_MAPPING_ORG_ID,
	JAB_CC_SKU_PHOTO_MAPPING_ORG_ID
];

export const ICH_SKU_PHOTO_MAPPING_CATALOG_ID = "ich-structural";
export const JAB_CC_SKU_PHOTO_MAPPING_CATALOG_ID = "jab-cc";

export function isSkuPhotoMappingOrganization(orgId = "") {
	return SKU_PHOTO_MAPPING_ORG_IDS.includes(`${orgId || ""}`.trim());
}

export function getSkuPhotoMappingCatalogId(orgId = "") {
	const normalizedOrgId = `${orgId || ""}`.trim();
	if (normalizedOrgId === ICH_SKU_PHOTO_MAPPING_ORG_ID) {
		return ICH_SKU_PHOTO_MAPPING_CATALOG_ID;
	}
	if (normalizedOrgId === JAB_CC_SKU_PHOTO_MAPPING_ORG_ID) {
		return JAB_CC_SKU_PHOTO_MAPPING_CATALOG_ID;
	}
	return "";
}
